// Single place to update store + contact info before launch.
export const EXTENSION_ID="ajfbbiinmfamfajblcpbbhbojhbibmii";
export const CHROME_STORE_URL =
  `https://chrome.google.com/webstore/detail/${EXTENSION_ID}`;
export const SUPPORT_EMAIL = 'vilay17bende@gmail.com';
